import React from "react"
import WrappedInput from "./WrappedInput"
import { nonBilableReasonsOptions, departmentValidation } from "./callSheetConstants"
import Icon from "@cloudbreakus/cloudbreak-react-icon"

const wizardIcons = {
  complete: {
    icon: "IoMdCheckmark",
    color: "green",
  },
  partial: {
    icon: "warning",
    color: "orange",
    message: "Complete all required fields",
  },
  empty: {
    icon: "error",
    color: "red",
    message: "Required fields not complete",
  },
}

const CallDetailsSection = ({
  interactionId,
  language,
  partnerName,
  unitId,
  partnerLocationId,
  partnerLocations,
  department,
  departmentName,
  nonBillableReasons,
  departmentOptions,
  showCollectDepartment,
  onNonBillableReasons,
  onPartnerLocation,
  onDepartment,
  customerPhoneNumber,
  exitConfirmation,
  wizardStatus,
  showIntakeForm,
}) => {
  return (
    <div className="py-2 flex flex-col">
      <div className="flex w-full px-2">
        <span className="text-left text-gray-600 flex-grow font-semibold">Call Details</span>
        <span className="font-bold">{wizardIcons[wizardStatus]?.message}</span>
        <Icon icon={wizardIcons[wizardStatus]?.icon} className="mt-1 ml-2" color={wizardIcons[wizardStatus]?.color} />
      </div>
      <div className="w-full inline-flex flex-row flex-wrap">
        <WrappedInput name="interaction-id" label="Interaction ID *" value={interactionId} disabled />
        <WrappedInput name="account" label="Account *" value={partnerName} disabled />
        <WrappedInput name="unit-id" label="Unit ID *" value={customerPhoneNumber || unitId} disabled />
        <WrappedInput
          name="non-billable-reasons"
          label="Non Billable Reasons *"
          value={nonBillableReasons}
          onChange={onNonBillableReasons}
          options={nonBilableReasonsOptions}
          type={"select"}
          disabled={exitConfirmation}
        />
        <WrappedInput
          name="language"
          label="Language *"
          value={language}
          options={[`${language}`]}
          type={"select"}
          disabled
        />
        {partnerLocations?.length > 0 && showIntakeForm && (
          <WrappedInput
            name="location"
            label="Location"
            options={partnerLocations}
            type={"treeSelect"}
            value={partnerLocationId}
            disabled={exitConfirmation}
            treeDefaultExpandAll
            validation={null}
            allowClear={false}
            onChange={onPartnerLocation}
          />
        )}
        {showCollectDepartment && showIntakeForm && (
          <WrappedInput
            name="department"
            label="Department *"
            value={department || departmentName}
            options={departmentOptions?.length > 0 ? departmentOptions : [`${departmentName}`]}
            onChange={onDepartment}
            type={"select"}
            disabled={exitConfirmation || !departmentOptions?.length}
            validation={departmentValidation}
          />
        )}
      </div>
    </div>
  )
}

export default CallDetailsSection
